<template>
    <div id="app">
        <transition name="fade-in-left" appear>
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="scss">
    @import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
    @import "./assets/colors.scss";


    #app {
        margin: 0;
    }

    html, body {
        margin: 0;
        padding: 0;
        background: white;
        font-family: 'Roboto', sans-serif;
    }

    input[type=number] {
        -moz-appearance: textfield;
        appearance: textfield;
        margin: 0;
    }

    @keyframes fadeInLeft {
        from {
            transform: translate3d(-40px, 0, 0);
        }

        to {
            transform: translate3d(0, 0, 0);
            opacity: 1
        }
    }

    .fade-in-left-leave-to {
        opacity: 0;
        transition: opacity .3s;
    }

    .fade-in-left-enter {
        opacity: 0;
        transform: translate3d(-40px, 0, 0);
    }

    .fade-in-left-enter-to {
        opacity: 0;
        animation-duration: .7s;
        animation-fill-mode: both;
        animation-name: fadeInLeft;
    }
</style>
